import { Provider } from "../../Context";
import OrcamentoList from "./List";
import { Actions } from "./Actions";
import Form from "./Form";


function AppOrcamento() {
  const data = Actions();
  return (
    <Provider value={data}>
      <div className="App">
        <h1>Orçamentos</h1>
        <ul class="collapsible">
          <li>
            <div class="collapsible-header"><i class="material-icons">add</i>Novo Orçamento</div>
            <div class="collapsible-body">
              <div className="row">
                <Form />
              </div>
            </div>
          </li>
          <li class="active">
            <div class="collapsible-header"><i class="material-icons">search</i>Lista de Orçamentos</div>
            <div class="collapsible-body">
              <div className="row">
                <OrcamentoList />
              </div>
            </div>
          </li>
        </ul>
      </div>
    </Provider>
  );
}

export default AppOrcamento;